import React, { useEffect, useState, useRef } from "react";
import { Box, Text } from "@chakra-ui/react";
import { useTutor } from "../../../context/AiTutorContext";
import { fechSuggestions } from "../../../network/TutorApiService";
import { isEmptyOrNull } from "../../../utils/common-utils";
import pkg from "@inrscr/coschool-ui-components";
import { getFetchQuestionByID } from "../../../network/LearnApiService";

export default function SuggestionBox({ handleDoubtFlow, onReset }) {
  const { LatexRender } = pkg;
  const { userQuery, curriculumObj, setDoubtQuestionObj } = useTutor();
  const [filterdData, setFilterdData] = useState([]);
  const [triggeredOnce, setTriggeredOnce] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [spaceCount, setSpaceCount] = useState(0);
  const prevSpaceCount = useRef(0);
  const apiTriggerLimit = useRef(
    window?.ENV?.SUGGESTION_API_TRIGGER_LIMIT || 3
  );

  useEffect(() => {
    if (userQuery?.trim()?.length == 0) {
      prevSpaceCount.current = 0;
      setSpaceCount(0);
      setTriggeredOnce(false);
      setFilterdData([]);
    } else {
      const currentSpaceCount = countSpaces(userQuery);
      setSpaceCount(currentSpaceCount);
      if (currentSpaceCount < prevSpaceCount?.current) {
        prevSpaceCount.current = currentSpaceCount;
      }
    }
  }, [userQuery]);

  function countSpaces(inputString) {
    const normalizedString = inputString.replace(/&nbsp;/g, " ");
    const spaceMatches = normalizedString.match(/\s/g);
    return spaceMatches ? spaceMatches.length : 0;
  }


  useEffect(() => {
    if (!isEmptyOrNull(userQuery?.trim()) && !isLoading) {
      if (shouldTriggerAPI(spaceCount)) {
        getSuggestion();
      }
    }
  }, [userQuery, curriculumObj, isLoading, spaceCount]);

  const handleReset = () => {
    setTriggeredOnce(false);
    setSpaceCount(0);
    setFilterdData([]);
    prevSpaceCount.current = 0;
    onReset();
  };
  const handleSelectItem = async (item) => {
    const { uuid } = item;
    let quesObj = await handleFetchQuestion(uuid);
    handleReset();
    setDoubtQuestionObj(quesObj);
    handleDoubtFlow("", quesObj);
  };
  const handleFetchQuestion = async (uuid) => {
    let { data } = await getFetchQuestionByID(uuid);
    return data?.results?.[0] || {};
  };

  const shouldTriggerAPI = (currentSpaceCount) => {
    if (!triggeredOnce && currentSpaceCount >= apiTriggerLimit?.current) {
      setTriggeredOnce(true);
      prevSpaceCount.current = currentSpaceCount;
      return true;
    } else if (triggeredOnce && currentSpaceCount > prevSpaceCount.current) {
      prevSpaceCount.current = currentSpaceCount;
      return true;
    }

    return false;
  };

  const getSuggestion = async () => {
    if (curriculumObj?.topic_name_id) {
      setIsLoading(true);
      let body = {
        query: userQuery,
        topic_id: curriculumObj?.topic_name_id,
      };
      try {
        const { data = {}, success } = await fechSuggestions(body);
        if (success) {
          setFilterdData(data);
        } else {
          setFilterdData([]);
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
        setFilterdData([]);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <Box w={"100%"} ml={["10%", "15%"]}>
      {(triggeredOnce || spaceCount >= apiTriggerLimit?.current) &&
        !isLoading &&
        filterdData?.length > 0 && (
          <Box
            bg={"#FFFFFF"}
            h={"160px"}
            border={"1px solid #0000003D"}
            w={["80%", "70%"]}
            borderRadius={8}
            overflowY={"auto"}
            boxShadow={"0px 4px 6px rgba(0, 0, 0, 0.1)"}
          >
            {filterdData.map((item, index) => {
              return (
                <Text
                  key={index}
                  cursor={"pointer"}
                  _hover={{
                    bg: "#DAD7EB66",
                  }}
                  fontSize={"14px"}
                  fontWeight={"400"}
                  lineHeight={"20px"}
                  p={2}
                  onClick={() => {
                    handleSelectItem(item);
                  }}
                >
                  <LatexRender math={item?.question} />
                </Text>
              );
            })}
          </Box>
        )}
    </Box>
  );
}
